import { offerElementTypeOptions } from '@/assets/locales/views/offerElements/offerElements.common.translation.pl.ts';

export const offerElementEditorTranslation = {
  above: {
    flat: 'Stała kwota',
    label: 'Powyżej ostatniego progu',
    manual: 'Wycena indywidualna',
    none: 'Brak ceny',
    noneHint: 'Powyżej ostatniego progu składowej nie da się dodać do oferty.',
    rate: {
      guestTiers: 'Stawka za każdą kolejną osobę',
      hourTiers: 'Stawka za każdą kolejną godzinę',
    },
  },
  attention: {
    ending: 'Cennik się kończy',
    missing: 'Bez ceny na dziś',
  },
  basics: {
    active: 'Aktywna',
    activeHint:
      'Wyłączona składowa znika z wyboru w ofertach, istniejące oferty zostają bez zmian.',
    category: 'Grupa',
    categoryHint:
      'Np. „Meble bankietowe” albo „Kelnerzy”. Grupy porządkują listę i wybór w ofercie.',
    description: 'Uwagi',
    descriptionHint:
      'Widzi je handlowiec przy wyborze składowej i asystent AI, np. „1 kucharz na 30–40 osób”.',
    inactive: 'Wyłączona',
    name: 'Nazwa',
    newCategory: 'Nowa grupa',
    similar: 'Podobne w katalogu: {{names}}. Sprawdź, czy to nie duplikat.',
    type: 'Typ',
  },
  browse: {
    counter: 'Składowa {{number}} z {{count}}',
    empty: 'Brak składowych do przejrzenia — zmień filtry listy.',
    keyboardHint:
      '← / → poprzednia i następna składowa · Ctrl+S zapisuje · zmiany zapisują się przy przejściu',
    nextHint: 'Następna składowa (→)',
    nextPage: 'Następne 50 składowych',
    page: 'Strona {{number}} z {{count}}',
    previousHint: 'Poprzednia składowa (←)',
    previousPage: 'Poprzednie 50 składowych',
  },
  close: 'Zamknij',
  complete: 'Wszystkie wymagane pola są uzupełnione.',
  create: {
    back: 'Wstecz',
    cancel: 'Anuluj',
    discardMessage: 'Wpisana składowa nie została zapisana. Zamknąć okno i porzucić ją?',
    kept: 'Przy „Zapisz i dodaj kolejną” zostaje typ, grupa i sposób liczenia.',
    next: 'Dalej',
    save: 'Zapisz',
    saveAndAdd: 'Zapisz i dodaj kolejną',
    steps: {
      basics: 'Co to jest',
      method: 'Jak liczymy cenę',
      prices: 'Cennik',
      summary: 'Sprawdź i zapisz',
    },
    title: 'Dodaj składową oferty',
  },
  discard: {
    confirm: 'Zamknij bez zapisu',
    message:
      'Składowa ma zmiany, których nie da się zapisać, bo brakuje wymaganych pól. Zamknąć bez zapisu?',
    title: 'Porzucić zmiany?',
  },
  extend: {
    hint: 'Zmienia tylko datę końca. Kwoty cennika zostają bez zmian.',
    save: 'Zapisz datę',
    title: 'Do kiedy obowiązuje cennik?',
    validTo: 'Ważny do',
  },
  howMuch: {
    gross: '{{value}} brutto',
    guests: 'Goście',
    hours: 'Długość wydarzenia (h)',
    missing: 'Powyżej {{above}} brak ceny — składowej nie da się dodać do takiej oferty.',
    net: 'netto',
    quantity: 'Ilość',
    timesQuantity: ' × {{quantity}}',
    title: 'Ile wyjdzie',
    units: {
      guests: 'os.',
      hours: 'h',
      piece: 'szt.',
    },
    why: {
      above: 'Powyżej {{from}}: {{price}}',
      blocks: '{{blocks}} × {{price}} (za każde rozpoczęte {{size}} {{unit}})',
      manual: 'Wycena indywidualna — handlowiec wpisuje kwotę w ofercie.',
      oversize: 'Próg „do {{upTo}}”: {{price}} + {{extra}} × {{rate}}',
      tier: 'Próg „do {{upTo}}”: {{price}}',
      unit: '{{quantity}} × {{price}}',
    },
  },
  method: {
    examples: {
      guestTiers: 'Transport Warszawa: do 30 os. 350 zł, do 70 os. 450 zł…',
      hourTiers: 'Kelner: do 8 h 550 zł, do 12 h 650 zł…',
      manual: 'Kwiaty: cena zakupu + 100%, handlowiec wpisuje kwotę',
      perGuests: 'Stół dla gości: 40 zł za każde rozpoczęte 6 osób',
      perHours: 'Koordynator: kwota za każde rozpoczęte N godzin',
      unit: 'Namiot 3 × 6 m: 600 zł × ilość',
    },
    hint: 'Liczba gości i godziny biorą się z oferty, więc po ich zmianie cena przelicza się sama.',
    labels: {
      guestTiers: 'Progi wg liczby gości',
      hourTiers: 'Progi wg długości wydarzenia',
      manual: 'Wycena indywidualna',
      perGuests: 'Za osoby',
      perHours: 'Za godziny',
      unit: 'Za sztukę',
    },
    lockedHint: 'Sposobu liczenia nie zmienia się po zapisie — wyłącz składową i dodaj nową.',
  },
  newPrices: {
    hint:
      'Kwot zapisanego cennika się nie zmienia. Nowy cennik zaczyna się najwcześniej jutro, a ten, ' +
      'który obowiązuje w tym dniu, kończy się dzień wcześniej. Złożone oferty zachowują swoje kwoty.',
    save: 'Zapisz nowe ceny',
    title: 'Nowe ceny od…',
  },
  openPreview: 'Podgląd jak w ofercie',
  periods: {
    current: 'Obowiązuje',
    future: 'Od {{date}}',
    past: 'Zakończony',
  },
  previous: 'Poprzednia',
  priceList: {
    above: 'powyżej {{upTo}}',
    blockSize: {
      perGuests: 'Za każde rozpoczęte … osób',
      perHours: 'Za każde rozpoczęte … godzin',
    },
    extend: 'Przedłuż do…',
    manualChip: 'wycena indywidualna',
    manualHint: 'Wskazówka do wyceny',
    manualHintPlaceholder: 'Np. cena zakupu kwiatów + 100%',
    newPrices: 'Nowe ceny od…',
    noPrices: 'Brak cennika',
    oversize: 'każda kolejna: {{rate}}',
    perBlock: '{{price}} za każde rozpoczęte {{size}} {{unit}}',
    perPerson: '{{price}} za osobę',
    perUnit: '{{price}} za sztukę',
    price: 'Cena minimalna netto',
    tierAdd: 'Dodaj próg',
    tierComment: 'Wskazówka (opcjonalnie)',
    tierPrice: 'Kwota za przedział',
    tierRemove: 'Usuń próg',
    tiersHint:
      'Kwota progu to cena za cały przedział, nie za jednostkę. Mnożenie zaczyna się dopiero ' +
      'powyżej ostatniego progu, jeśli wybierzesz stawkę.',
    tierUpTo: {
      guestTiers: 'Do liczby gości',
      hourTiers: 'Do godzin',
    },
    title: 'Cennik',
    upTo: 'do {{upTo}}',
    validFrom: 'Ważny od',
    validity: '{{from}} – {{to}}',
    validTo: 'Ważny do',
  },
  problems: {
    aboveAmount: 'Podaj kwotę powyżej ostatniego progu.',
    blockSize: 'Podaj, za ile osób albo godzin liczona jest cena.',
    method: 'Wybierz sposób liczenia ceny.',
    name: 'Podaj nazwę.',
    price: 'Podaj cenę.',
    tiers: 'Uzupełnij próg i kwotę w każdym wierszu.',
    tiersOrder: 'Progi muszą rosnąć z wiersza na wiersz.',
    type: 'Wybierz typ.',
    validity: 'Data końca cennika nie może być wcześniejsza niż początek.',
  },
  remaining: 'Do uzupełnienia: {{fields}}',
  save: 'Zapisz',
  saveAndClose: 'Zapisz i zamknij',
  saveAndFinish: 'Zapisz i zakończ',
  saveAndNext: 'Zapisz i dalej',
  saved: 'Zapisano',
  saving: 'Zapisywanie…',
  summary: {
    items: 'Co wchodzi w skład: {{items}}',
    method: 'Sposób liczenia: {{method}}',
    unitPeople: 'Ilość w ofercie wylicza się z liczby gości.',
    validity: 'Cennik od {{from}} do {{to}}, VAT 23%.',
  },
  titleBrowse: 'Przeglądanie składowych',
  titleEdit: 'Edycja składowej',
  toast: {
    created: 'Dodano składową „{{name}}”.',
    extended: 'Cennik obowiązuje teraz do {{date}}.',
    missing: 'Uzupełnij: {{fields}}',
    newPrices: 'Nowe ceny obowiązują od {{date}}.',
    saved: 'Zapisano „{{name}}”.',
  },
  types: offerElementTypeOptions,
  unsaved: 'Niezapisane zmiany',
};

export type OfferElementEditorTranslation = typeof offerElementEditorTranslation;
